import React, {useState, useRef} from 'react'
import tw from 'twin.macro'
import emailjs from '@emailjs/browser';

const Div = tw.div`flex justify-center items-center h-screen`
const Divss = tw.div`lg:mx-10 text-center rounded-sm`
const Divs = tw.div`mx-4 md:mx-20 text-center bg-gray-400 py-5 lg:py-10 px-5 lg:px-0 lg:pr-10 rounded-sm`
const InputText = tw.input`outline-none bg-gray-200 w-full px-4 py-3 text-lg font-semibold text-gray-800 mt-4`
const SendText = tw.input`bg-gray-800 outline-none text-center cursor-pointer  rounded-sm w-full lg:ml-10 px-4 py-3 text-lg font-semibold text-gray-200 mt-4`
const TextAria = tw.textarea`outline-none bg-gray-200 w-full px-3 py-3 text-lg font-semibold text-gray-800 mt-4`
const Text = tw.text`lg:text-6xl text-3xl text-center w-full  font-bold text-gray-700`
const Span = tw.text`text-yellow-600`
const Flex = tw.div`lg:flex lg:py-10`
const DivEnd = tw.div`flex justify-end`

function ContactUs() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_tl15lc9', 'template_sz35npf', form.current, 'vnnL05AAeI04Cgh62')
      .then((result) => {
        console.log(result.text);
        form.current={}
      }, (error) => {
        console.log(error.text);
      });
  };
  return (


    <Div>
       <Divs>
         <Text><Span>FLEX</Span>  POSTER</Text>
    <form ref={form} onSubmit={sendEmail}>
            <Flex>
             <Divss>
   
      <InputText placeholder="Your Name" type="text" name="name" />
     
              <InputText  placeholder="Your email" type="email" name="email" />
      
              <InputText placeholder="Your Number" type="number" name="phone" />
              </Divss>
     
            
            <TextAria placeholder="Your Message" name="message" />
          </Flex>
             <DivEnd>
              
      <SendText type="submit" value="Send" />
             </DivEnd>
        </form>
      </Divs>
     </Div>
  )
}

export default ContactUs